import { render, staticRenderFns } from "./RegulationForm.vue?vue&type=template&id=69bda721&scoped=true&"
import script from "./RegulationForm.vue?vue&type=script&lang=js&"
export * from "./RegulationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bda721",
  null
  
)

export default component.exports